import React, { useState, Fragment } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/gattomioNero.png';
import paws8 from '../../images/paws-8.png';
import paws10 from '../../images/paws-10.png';
import { resetPassword } from '../../api/backend';
import '../LoginPage/AuthPage.scss';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token') || '';
  const emailFromUrl = searchParams.get('email') || '';

  const [formData, setFormData] = useState({
    password: '',
    password_confirmation: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState('');
  const [done, setDone] = useState(false);

  const validate = () => {
    const errors = {};
    if (!formData.password) errors.password = 'Password obbligatoria';
    else if (formData.password.length < 8) errors.password = 'Minimo 8 caratteri';
    if (!formData.password_confirmation) errors.password_confirmation = 'Conferma la password';
    else if (formData.password !== formData.password_confirmation) errors.password_confirmation = 'Le password non coincidono';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (formErrors[e.target.name]) setFormErrors({ ...formErrors, [e.target.name]: '' });
    if (apiError) setApiError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      await resetPassword({
        token,
        email: emailFromUrl,
        password: formData.password,
        password_confirmation: formData.password_confirmation,
      });
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      const msg = err?.response?.data?.message || 'Il link di reset non è valido o è scaduto.';
      setApiError(msg);
    } finally {
      setLoading(false);
    }
  };

  // Token mancante nell'URL
  if (!token) {
    return (
      <Fragment>
        <Navbar hclass={'wpo-site-header'} Logo={Logo} />
        <PageTitle pageTitle={'Link non valido'} pagesub={'Reset password'} />
        <section className="wpo-auth-section section-padding">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-8">
                <div className="auth-wrapper">
                  <div className="auth-form-panel" style={{ textAlign: 'center' }}>
                    <div className="auth-success-state">
                      <div className="auth-success-icon auth-error-icon">
                        <i className="ti-close"></i>
                      </div>
                      <h2>Link non valido</h2>
                      <p>Il link di reset è mancante o non valido. Richiedi un nuovo link.</p>
                      <Link to="/forgot-password" className="theme-btn auth-success-btn">
                        Richiedi nuovo link
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
        <Scrollbar />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Navbar hclass={'wpo-site-header'} Logo={Logo} />
      <PageTitle pageTitle={'Nuova password'} pagesub={'Reset password'} />

      <section className="wpo-auth-section section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">

              <div className="auth-wrapper">
                {/* Left decorative panel */}
                <div className="auth-side-panel">
                  <div className="side-panel-content">
                    <div className="side-panel-icon">
                      <img src={paws8} alt="Petlox paw" />
                    </div>
                    <h3>Crea una nuova password</h3>
                    <p>
                      Scegli una password sicura di almeno 8 caratteri
                      per proteggere il tuo account Petlox.
                    </p>
                    <Link to="/login" className="side-panel-btn">
                      Torna al login
                    </Link>
                  </div>
                </div>

                {/* Right form panel */}
                <div className="auth-form-panel">
                  {done ? (
                    <div className="auth-success-state">
                      <div className="auth-success-icon">
                        <i className="ti-check"></i>
                      </div>
                      <h2>Password aggiornata!</h2>
                      <p>
                        La tua password è stata reimpostata con successo.
                        Verrai reindirizzato al login tra pochi secondi.
                      </p>
                      <Link to="/login" className="theme-btn auth-success-btn">
                        Vai al login
                      </Link>
                    </div>
                  ) : (
                    <>
                      <div className="auth-form-header">
                        <span className="auth-subtitle">Reset password</span>
                        <h2>Nuova password</h2>
                        <p>Inserisci la tua nuova password per <strong>{emailFromUrl}</strong></p>
                      </div>

                      {apiError && (
                        <div className="auth-alert">
                          <span className="alert-icon"><i className="ti-alert"></i></span>
                          <p>{apiError}</p>
                        </div>
                      )}

                      <form className="auth-form" onSubmit={handleSubmit} noValidate>
                        <div className="form-group">
                          <label>Nuova password</label>
                          <div className="input-wrapper">
                            <input
                              type="password"
                              name="password"
                              className={formErrors.password ? 'is-invalid' : ''}
                              value={formData.password}
                              onChange={handleChange}
                              placeholder="Minimo 8 caratteri"
                              autoComplete="new-password"
                            />
                            <i className="ti-lock field-icon"></i>
                          </div>
                          {formErrors.password && <div className="invalid-feedback">{formErrors.password}</div>}
                        </div>

                        <div className="form-group">
                          <label>Conferma nuova password</label>
                          <div className="input-wrapper">
                            <input
                              type="password"
                              name="password_confirmation"
                              className={formErrors.password_confirmation ? 'is-invalid' : ''}
                              value={formData.password_confirmation}
                              onChange={handleChange}
                              placeholder="Ripeti la password"
                              autoComplete="new-password"
                            />
                            <i className="ti-lock field-icon"></i>
                          </div>
                          {formErrors.password_confirmation && <div className="invalid-feedback">{formErrors.password_confirmation}</div>}
                        </div>

                        <div className="submit-area">
                          <button type="submit" className="theme-btn" disabled={loading}>
                            {loading ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Salvataggio...
                              </>
                            ) : 'Imposta nuova password'}
                          </button>
                        </div>
                      </form>

                      <div className="auth-switch-link" style={{ marginTop: '20px' }}>
                        <p>
                          Link scaduto?{' '}
                          <Link to="/forgot-password">Richiedine uno nuovo</Link>
                        </p>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <img src={paws8} alt="" className="paw-decoration paw-top-right" />
              <img src={paws10} alt="" className="paw-decoration paw-bottom-left" />

            </div>
          </div>
        </div>
      </section>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default ResetPasswordPage;
